class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.onNestedToggle = this.onNestedToggle.bind(this);
    
    this.hoverTimeout = null;
    this.listenersAttached = false;
    this.mql = window.matchMedia('(min-width: 1199px)');
  }

  connectedCallback() {
    if (super.connectedCallback) {
      super.connectedCallback();
    }
    this.handleViewportChange(this.mql);
    this.mql.addEventListener('change', this.onViewportChange);
  }

  disconnectedCallback() {
    if (super.disconnectedCallback) {
      super.disconnectedCallback();
    }
    this.removeHoverListeners();
    this.mql.removeEventListener('change', this.onViewportChange);
  }

  onViewportChange(event) {
    this.handleViewportChange(event);
  }

  handleViewportChange(mql) {
    if (mql.matches) {
      this.attachHoverListeners();
    } else {
      this.removeHoverListeners();
    }
  }

  attachHoverListeners() {
    if (this.listenersAttached) return;
    this.allDetails = this.querySelectorAll('details');
    this.allDetails.forEach((details) => {
      details.addEventListener('mouseenter', this.onMouseEnter);
      details.addEventListener('mouseleave', this.onMouseLeave);
      details.addEventListener('toggle', this.onNestedToggle);
      
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', this.onSummaryClick);
      }
    });
    this.listenersAttached = true;
  }

  removeHoverListeners() {
    if (!this.listenersAttached) return;
    if (this.allDetails) {
      this.allDetails.forEach((details) => {
        details.removeEventListener('mouseenter', this.onMouseEnter);
        details.removeEventListener('mouseleave', this.onMouseLeave);
        details.removeEventListener('toggle', this.onNestedToggle);
        
        const summary = details.querySelector('summary');
        if (summary) {
          summary.removeEventListener('click', this.onSummaryClick);
        }
        
        if (details._hoverTimeout) {
          clearTimeout(details._hoverTimeout);
          details._hoverTimeout = null;
        }
      });
    }
    this.listenersAttached = false;
  }

  onMouseEnter(event) {
    const details = event.currentTarget;
    
    // Clear timeouts for this details and all of its ancestor details
    let parent = details;
    while (parent) {
      if (parent.tagName === 'DETAILS') {
        if (parent._hoverTimeout) {
          clearTimeout(parent._hoverTimeout);
          parent._hoverTimeout = null;
        }
      }
      parent = parent.parentElement;
    }

    if (!details.hasAttribute('open')) {
      details.setAttribute('open', '');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
      
      // Position nested submenus immediately on hover
      if (details.id.startsWith('Details-HeaderSubMenu')) {
        this.positionSubmenu(details);
      }
    }
  }

  onMouseLeave(event) {
    const details = event.currentTarget;
    if (details._hoverTimeout) {
      clearTimeout(details._hoverTimeout);
    }
    details._hoverTimeout = setTimeout(() => {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }, 150);
  }

  onSummaryClick(event) {
    if (event.target.closest('a')) return;
    if (event.detail > 0 || event.clientX > 0 || event.clientY > 0) {
      event.preventDefault();
    }
  }

  onNestedToggle(event) {
    const details = event.currentTarget;
    if (details.hasAttribute('open') && details.id.startsWith('Details-HeaderSubMenu')) {
      this.positionSubmenu(details);
    }
  }

  positionSubmenu(details) {
    const submenu = details.querySelector('.header__submenu');
    if (!submenu) return;
    
    // Reset any previous alignment
    submenu.classList.remove('submenu-open-left');
    
    // Calculate boundaries relative to viewport
    const rect = submenu.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    
    // If it overflows the viewport boundary on the right, open to the left instead
    if (rect.right > viewportWidth) {
      submenu.classList.add('submenu-open-left');
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
